(function () {
  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isCollectionPage() {
    return document.body.classList.contains('collection-ecom-brand-new-collection');
  }

  function getMobileHeaderOffset() {
    var maxBottom = 0;
    var selectors = [
      '.announcement-bar',
      '[id*="announcement"]',
      '#header',
      '.shopify-section-group-header-group',
      '[id*="shopify-section"][id*="header"]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (element) {
      if (!element || !element.offsetParent) {
        return;
      }

      var rect = element.getBoundingClientRect();
      if (rect.height <= 0) {
        return;
      }

      maxBottom = Math.max(maxBottom, rect.bottom);
    });

    return Math.max(0, Math.ceil(maxBottom));
  }

  var syncQueued = false;

  function syncHeaderOffset() {
    if (!isCollectionPage() || !isMobileViewport()) {
      document.documentElement.style.removeProperty('--roi-mobile-header-offset');
      document.documentElement.style.removeProperty('--roi-mobile-filter-offset');
      return;
    }

    var headerOffset = getMobileHeaderOffset();
    document.documentElement.style.setProperty('--roi-mobile-header-offset', headerOffset + 'px');
    document.documentElement.style.setProperty('--roi-mobile-filter-offset', (headerOffset + 16) + 'px');
  }

  function queueSync() {
    if (syncQueued) {
      return;
    }

    syncQueued = true;

    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncHeaderOffset();
    });
  }

  document.addEventListener('DOMContentLoaded', queueSync);
  window.addEventListener('load', queueSync);
  window.addEventListener('pageshow', queueSync);
  window.addEventListener('resize', queueSync);
  window.addEventListener('orientationchange', queueSync);
  window.setTimeout(queueSync, 250);
})();
